export default {
  title: "Notificaciones",
  viewAll: "Ver todas",
  markAsRead: "Marcar como leída",
  markAllAsRead: "Marcar todas como leídas",
  noNotifications: "No hay notificaciones",
  types: {
    info: "Información",
    warning: "Advertencia",
    error: "Error",
    success: "Éxito"
  },
  actions: {
    view: "Ver",
    dismiss: "Descartar",
    accept: "Aceptar",
    decline: "Rechazar"
  },
  categories: {
    system: "Sistema",
    tasks: "Tareas",
    guests: "Invitados",
    budget: "Presupuesto",
    vendors: "Proveedores",
    timeline: "Planificación",
    achievements: "Éxito",
    weddingWebsite: "Sitio web de boda"
  },
  settings: {
    title: "Configuración de notificaciones",
    push: {
      title: "Notificaciones push",
      description: "Recibe notificaciones incluso sin usar la aplicación"
    },
    categories: {
      title: "Categorías de notificación"
    },
    other: {
      title: "Otras notificaciones",
      email: {
        title: "Notificaciones por correo",
        description: "Recibe actualizaciones importantes por correo"
      },
      desktop: {
        title: "Notificaciones de escritorio",
        description: "Recibe notificaciones en tu computadora"
      }
    },
    testButton: "Probar notificaciones"
  },
  errors: {
    loadPreferences: "Error al cargar las preferencias",
    pushToggle: "Error al modificar las notificaciones push",
    categoryToggle: "Error al modificar las categorías"
  }
};
